<template>
  <div class="detail">
      <div class="info">
          <p>基本信息</p>
          <div class="info_main">
              <ul>
                 <li>订货单ID: <span>{{orderDetailsVo.id}}</span></li> 
                 <li>订货单名称: <span>{{orderDetailsVo.orderName}}</span></li> 
                 <li>状态: <span>{{orderDetailsVo.state == 1?'待发货': orderDetailsVo.state == 2?'待收货':'已收货'}}</span></li> 
                 <li>创建时间: <span>{{orderDetailsVo.createTime}}</span></li> 
              </ul>
          </div>
      </div>
      <div class="info">
          <p>收货信息</p>
          <div class="info_main">
              <ul>
                 <li>4s店: <span>{{orderDetailsVo.shopName}}</span></li> 
                 <li>收货人: <span>{{orderDetailsVo.consignee}}</span></li> 
                 <li>联系电话: <span>{{orderDetailsVo.phone}}</span></li> 
                 <li style="width:100%">收货地址: <span>{{orderDetailsVo.address}}</span></li> 
              </ul>
          </div>
      </div>
       <div class="info">
          <p>订货单明细</p>
          <div class="info_main" style="margin-top:15px">
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="orderDetailsVo.list"
                    style="width: 100%">
                    <el-table-column
                        prop="deviceId"
                        label="设备ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceName"
                        label="设备名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        label="数量">
                    </el-table-column>
                </el-table>
          </div>
      </div>
      <div class="info">
          <p>发货单明细</p>
          <div class="info_main" style="margin-top:15px">
              <ul>
                  <li>发货单号: <span>{{orderDetailsVo.trackingNumber}}</span></li>
                  <li>发货时间: <span>{{orderDetailsVo.deliveryTime}}</span></li>
              </ul>
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="orderDetailsVo.orderDeviceResList"
                    style="width: 100%;margin-top:15px">
                    <el-table-column
                        prop="deviceId"
                        label="设备ID"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceName"
                        label="设备名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        label="数量"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="deviceCodingList"
                        label="设备编码">
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.deviceCodingList" :key="index" style="display: block;width: 25%;text-align: center;float: left;margin-bottom:6px">{{item.toString()}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btn">
                    <el-button  v-preventReClick @click="goback()">返回</el-button>
                    <el-button  v-preventReClick type="primary" v-if="flag" @click="sureReceipt()">确认收货</el-button>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import {selectOrderById,updateOrderState} from '../axios/api'
export default {
    data(){
        return{
            tableData:[],
            tableDatasend:[],
            flag:false,
            orderDetailsVo:{},
            list:[]
        }
    },
    created(){
        console.log(this.$route.params)
        window.localStorage.setItem('ids',this.$route.params.id)
        if(this.$route.params.flag){
            this.flag = true
        }
        this.getdata()
    },
    methods:{
        sureReceipt(){
            this.$confirm('请核对实际收货数量与发货明细中的设备是否一致?', '确认收货', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await updateOrderState({
                        orderId:window.localStorage.getItem('ids')
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: dt.message
                        });
                        this.getdata()
                    }
                
                this.flag = false
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消收货'
                });          
            });
        },
        async getdata(){
            var {data:dt} = await selectOrderById({
                orderId:window.localStorage.getItem('ids')
            })
            console.log(dt)
            if(dt.code == 200){
                this.orderDetailsVo = dt.data.orderDetailsVo
            }else if(dt.code == 401){
                window.localStorage.removeItem('name')
                window.localStorage.removeItem('shopId')
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('state')
                this.$router.push('/login')
            }
            
        },
        goback(){
            this.$router.push('/orderfrom')
        }
    }
}

</script>
<style lang="less" scoped>
.detail{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .info{
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 15px;
        box-sizing: border-box;
        p{
            font-size: 18px;
            font-weight: 700;
            height: 40px;
            line-height: 40px;
        }
        .info_main{
            ul{
                overflow: hidden;
                width: 100%;
                li{
                    width: 33.3%;
                    float: left;
                    height: 35px;
                    line-height: 35px;
                    font-size: 14px;
                }
            }
        }
        .btn{
            margin-top: 55px;
            button{
                width: 10%;
                margin-right: 2%;
            }
        }
    }
    .info:last-child{
        border-bottom: none;
    }
}
</style>